import { Button, Dialog, DialogContent, DialogTitle, Slide } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function IdleTimerContainer() {
    const [openSessionMsg, setopenSessionMsg]  = useState(false)
    const navigate = useNavigate();

    const onIdle=()=>{
      setopenSessionMsg(true);
    }
    const logout=()=>{
        navigate('/')
        // console.log('time out')
    }
    const {getRemainingTime} = useIdleTimer({
      onIdle,
      timeout:5000000,
      throttle:500,
    })

      useEffect(() => {
    const interval = setInterval(() => {
      Math.ceil(getRemainingTime() / 1000)
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })
  return (
    <div>
      <Dialog open={openSessionMsg} maxWidth='sm' TransitionComponent={Transition}  keepMounted>
        <DialogTitle className='bg-danger p-1'>SESSION TIME OUT..!! </DialogTitle>
        <DialogContent>
          {/* <p>Because you haven't done anything for 5 minutes</p>
          <p>continue to work in our ERP Software</p> */}<br></br>
          <center><Button variant='contained' onClick={logout}>Logout</Button></center>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default IdleTimerContainer